import { defineStore } from 'pinia'

export const useStoreTema = defineStore('storeTema', {
  state: () => ({
    tema: localStorage.getItem('levelmember-tema') || 'claro'
  }),
  actions: {
    aplicarTema(novoTema) {
      this.tema = novoTema
      document.documentElement.setAttribute('data-theme', this.tema)
      localStorage.setItem('levelmember-tema', this.tema)
    },
    toggleTema() {
      this.aplicarTema(this.tema === 'claro' ? 'escuro' : 'claro')
    },
    carregarTema() {
      const temaSalvo = localStorage.getItem('levelmember-tema') || 'claro'
      this.aplicarTema(temaSalvo)
    }
  }
})
